import axios from "axios";
import { ITokenModel } from "models/Login/token.model";

export const Logout = async (logoutParams: ITokenModel) => {
  const reqData = serviceLogoutModelCreator(logoutParams);
  try {
    const { data } = await axios.post("/api/entrypoint", reqData, {
      headers: { Authorization: `Bearer ${logoutParams.access_token}` },
    });

    // if (data.DialogBoxes.length > 0) throw data.DialogBoxes[0].Message;
    return data.DialogBoxes.length === 0 ? true : false;
  } catch (error) {
    console.log(`LOGOUT_SERVICE_ERROR => `, error);
    throw error;
  }
};

const serviceLogoutModelCreator = (logoutParams: ITokenModel) => {
  let req = {
    iAccept: "true",
    CallbackFunctionId: null,
    isBusy: false,
    isNativeFlag: "true",
    Language: "tr-TR",
    TokenSessionId: logoutParams.TokenSessionId,
    igsEnc: null,
    NextTransactionUrl: "ModAuth/Logout",
  };

  return req;
};
